/**
 * userCopy.ts — 交付管理端「后端文案上屏前的内部痕迹收口」（t67 建）
 *
 * 背景：本端提示文案一律取后端信封的 `message`（client.ts:21 冻结口径），后端某一腿只要把内部标识
 * （物理表名 biz_courier、内部主键 id=…、英文异常原文、裸业务码）拼进 message，5173 就原样上屏。
 * 后端侧已按站点键汇点逐腿收口（code-api `CourierLegFailCopy`／`CourierLookupCopy`）；本文件是
 * 前端侧的**第二道闸**：上屏前判一次，内部腔调一律换成中性中文兜底，原文仍留在 `ApiError.message`
 * 里当取证事实位（traceId 报障口径不变）。
 *
 * 判据两条（⛔ 不打散到调用点，只此一处）：
 * ①无中日韩字符 ⇒ 非用户文案（本产品用户可见文案全中文；英文异常原文、裸码、HTTP 串都落这条）；
 * ②含中文字符但命中内部痕迹（物理表名／`id=<数字>`／`orderNo=`／异常类型名／`not found`／
 *   堆栈帧／大写 SNAKE 业务码）⇒ 也是内部腔调。
 * 命中即返回 `FALLBACK_USER_COPY`；未命中原样返回（后端已收口的好文案逐字透传，⛔ 不改写）。
 */

/** 用户可见兜底文案：说清「没成、可以怎么办」，⛔ 不含内部标识、英文标识与状态码 */
export const FALLBACK_USER_COPY = '请求未成功，请稍后重试；若持续失败请联系管理员';

/** 中日韩字符（用户可见文案的底线判据） */
const CJK = /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]/;

/** 内部痕迹（中文句里夹带也算） */
const INTERNAL_MARKERS: readonly RegExp[] = [
  /\b(?:biz|sys|fin)_[a-z0-9_]+/i, // 物理表名 biz_courier / sys_user / fin_settle_bill
  /\b[a-z]*[Ii]d\s*=\s*\S+/, // 内部主键回显 id=999999 / courierId=12
  /\borderNo\s*=/i, // 运单号键名回显（键名本身即内部措辞）
  /\b[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)+\b/, // 裸业务码 COURIER_NOT_FOUND / GRAB_CAS_CONFLICT
  /\bException\b/, // 异常类型名
  /\bnot found\b/i, // 英文异常原文
  /\bSystem\.[A-Za-z]/, // 命名空间/类型全名
  /\bat [A-Za-z_][\w.]*\(/, // 堆栈帧
];

/** 该文案是否像内部腔调（导出供断言与调用点复核） */
export function looksInternal(raw: string | null | undefined): boolean {
  const text = (raw ?? '').trim();
  if (text.length === 0) return true;
  if (!CJK.test(text)) return true;
  return INTERNAL_MARKERS.some((re) => re.test(text));
}

/** 上屏文案：内部腔调换兜底中文，其余原样返回 */
export function sanitizeUserCopy(raw: string | null | undefined): string {
  const text = (raw ?? '').trim();
  if (looksInternal(text)) return FALLBACK_USER_COPY;
  return text;
}
